import { atom } from 'recoil';

export const accordionItemsAtom = atom<string[]>({
  key: 'Accordion/items',
  default: [] as string[]
});
